import { z } from 'zod';
import { IsoTimestamp, QuizId, SchoolId, SessionId, UserId } from './common.js';
export const UnlockRequestState = z.enum([
    'uploading',
    'waiting',
    'approved',
    'denied',
    'expired',
    'resumed',
]);
export const UnlockDecisionChannel = z.enum(['readAloud', 'push']);
export const LockoutContext = z.object({
    reason: z.string().min(1).max(100),
    lockedAt: IsoTimestamp,
    pausedQuestionIndex: z.number().int().nonnegative(),
    totalQuestions: z.number().int().nonnegative(),
    pausedRemainingSec: z.number().int().nonnegative(),
    answeredCount: z.number().int().nonnegative(),
    attemptReference: z.string().min(1).max(32),
    proctorDisplayName: z.string().min(1).max(200).nullable(),
});
export const UnlockEvidenceDeclaration = z.object({
    contentType: z.enum(['image/jpeg', 'image/png']),
    sizeBytes: z.number().int().positive().max(2 * 1024 * 1024),
});
export const CreateUnlockRequest = z.object({
    clientRequestId: z.string().uuid(),
    reason: z.string().trim().min(10).max(500),
    evidence: UnlockEvidenceDeclaration.optional(),
});
export const UnlockRequest = z.object({
    id: z.string().uuid(),
    schoolId: SchoolId,
    quizId: QuizId,
    sessionId: SessionId,
    participantId: UserId,
    studentName: z.string().min(1).max(200).nullable(),
    studentNumber: z.string().max(64).nullable(),
    examTitle: z.string().min(1).max(200),
    examKind: z.enum(['exam', 'quiz']),
    state: UnlockRequestState,
    reason: z.string().min(10).max(500),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
    expiresAt: IsoTimestamp,
    evidenceRequired: z.boolean(),
    evidenceUploaded: z.boolean(),
    evidenceRetainedUntil: IsoTimestamp.nullable(),
    lockout: LockoutContext,
    decisionReason: z.string().max(500).nullable(),
    decisionChannel: UnlockDecisionChannel.nullable().default(null),
    decidedAt: IsoTimestamp.nullable().default(null),
    decidedByDisplayName: z.string().min(1).max(200).nullable().default(null),
    codeExpiresAt: IsoTimestamp.nullable().default(null),
});
export const CreateUnlockRequestResponse = z.object({
    request: UnlockRequest,
    upload: z.object({
        url: z.string().url(),
        method: z.literal('PUT'),
        contentType: z.enum(['image/jpeg', 'image/png']),
        expiresAt: IsoTimestamp,
    }).nullable(),
});
export const UnlockRequestResponse = z.object({ request: UnlockRequest.nullable() });
export const RedeemUnlockCodeRequest = z.object({
    code: z.string().trim().min(6).max(12),
});
//# sourceMappingURL=unlock-request.js.map